import React from "react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/img/Logo Avoconsulte white.svg";
import { urls, currentLang } from "../../shared/seo/links";
import "./chrome.css";

const CONTACT_EMAIL = "contact@avoconsulte.com";

const SOCIAL = [
  { href: "https://www.facebook.com/AvoConsulte/", icon: "fab fa-facebook-f", name: "Facebook" },
  { href: "https://mobile.twitter.com/avoconsulte", icon: "fab fa-twitter", name: "Twitter" },
  { href: "https://www.linkedin.com/company/avoconsulte", icon: "fab fa-linkedin-in", name: "LinkedIn" },
  { href: "https://www.pinterest.com/alaabenmbarek/", icon: "fab fa-pinterest", name: "Pinterest" },
];

// [governorate key (geo.js), label key]
const CITIES = [
  ["tunis", "Lawyer_Tunis"],
  ["ariana", "Lawyer_Ariana"],
  ["ben-arous", "Lawyer_Ben_arous"],
  ["sfax", "Lawyer_Sfax"],
  ["sousse", "Lawyer_Sousse"],
  ["nabeul", "Lawyer_Nabeul"],
  ["monastir", "Lawyer_Monastir"],
  ["bizerte", "Lawyer_Bizerte"],
];

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const lang = currentLang();
  const section = (type) => urls.toHref(urls.sectionPath(type, lang));
  const privacyHref = section("terms");

  const navLinks = [
    { href: urls.toHref(urls.homePath(lang)), label: t("Home") },
    { href: section("lawyers"), label: t("Lawyers") },
    { href: section("questions"), label: t("LegalAdvice") },
    { href: section("blogs"), label: t("LegalMagazine") },
    { href: section("about"), label: t("AboutUs") },
    { href: section("contact"), label: t("ContactUs") },
  ];

  return (
    <footer className="avc-footer">
      <div className="container">
        <div className="avc-footer__grid">
          <div className="avc-footer__brand">
            <img src={logo} alt="AvoConsulte" width="754" height="141" />
            <p className="avc-footer__tagline">{t("find_lawyer_near_you_description")}</p>
            <a href={"mailto:" + CONTACT_EMAIL} className="avc-footer__contact">
              <i className="far fa-envelope" aria-hidden="true"></i>
              {CONTACT_EMAIL}
            </a>
            <ul className="avc-footer__social">
              {SOCIAL.map((s) => (
                <li key={s.name}>
                  <a href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.name}>
                    <i className={s.icon} aria-hidden="true"></i>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="avc-footer__title">{t("footer_navigation")}</h2>
            <ul className="avc-footer__list">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="avc-footer__title">{t("footer_by_city")}</h2>
            <ul className="avc-footer__list">
              {CITIES.map(([key, label]) => (
                <li key={key}>
                  <a href={urls.toHref(urls.lawyersPath(lang, { governorate: key }))}>{t(label)}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="avc-footer__title">{t("footer_your_space")}</h2>
            <ul className="avc-footer__list">
              <li>
                <a href="/login">{t("Login")}</a>
              </li>
              <li>
                <a href="/Register">{t("Register_as_Client")}</a>
              </li>
              <li>
                <a href="/Register">{t("Register_as_Lawyer")}</a>
              </li>
              <li>
                <a href={privacyHref}>{t("PrivacyPolicy")}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="avc-footer__bottom">
        <div className="container avc-footer__bottom-inner">
          <p>
            &copy; {year} {t("AvoConsulte")}. {t("All_rights_reserved")}
          </p>
          <ul className="avc-footer__legal">
            <li>
              <a href={privacyHref}>{t("PrivacyPolicy")}</a>
            </li>
            <li>
              <a href={section("contact")}>{t("ContactUs")}</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
